import classNames from 'classnames';
import React from 'react';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import LineSpinner from './assets/igp-calculator-loader.svg?react';
import RectangleSpinner from './assets/igp-global-loading-spinner.svg?react';
import styles from './loading-spinner.module.scss';

type Props = {
  variant?: 'rectangle' | 'line';
  size?: 'regular' | 'big';
};

export const LoadingSpinner: React.FC<Props> = ({ variant = 'rectangle', size = 'regular' }) => {
  const { isAccentBackground } = useAccentBgContext();

  if (variant === 'line') {
    return (
      <LineSpinner
        className={classNames(styles.root, styles.line, {
          [styles.big]: size === 'big',
          [styles.onAccentBg]: isAccentBackground,
        })}
      />
    );
  }

  return (
    <RectangleSpinner
      className={classNames(styles.root, styles.rectangle, {
        [styles.big]: size === 'big',
        [styles.onAccentBg]: isAccentBackground,
      })}
    />
  );
};
